export default {
      id: "truckSatelliteHover-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons.svg#truckSatelliteHover",
      toString: function () {
        return this.url;
      }
    }